import { render, staticRenderFns } from "./ModalBidContent.vue?vue&type=template&id=a8868c74&scoped=true"
import script from "./ModalBidContent.vue?vue&type=script&lang=js"
export * from "./ModalBidContent.vue?vue&type=script&lang=js"
import style0 from "./ModalBidContent.vue?vue&type=style&index=0&id=a8868c74&prod&lang=stylus&scoped=true"
import style1 from "./ModalBidContent.vue?vue&type=style&index=1&id=a8868c74&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8868c74",
  null
  
)

export default component.exports